import clienteAxios from "../config/axios";

export async function getAbmReqSector () {
    return clienteAxios.get(`/abmReqSector`);
}

export async function uploadAbmReqSector () {
    return clienteAxios.post('/abmReqSector/actualizar');
}

export async function getAbmReqSectorByCodSem (codSem) {
    return clienteAxios.get(`/abmReqSector/${codSem}`);
}